import React from "react"
import Table from 'react-bootstrap/Table'
import 'bootstrap/dist/css/bootstrap.min.css'
import './schools.css'
import { FormattedMessage } from "react-intl"
import PieChart from "./PieChart";
import "./schools-student-body.css"

const SectionStudentBody = ({ schoolData }) => {
  const {
    percentFemaleStudents,
    totalUndergradStudents,
    percentInStateStudents,
    percentOutOfStateStudents,
    percentInternationalStudents,
    percentMaleStudents,
    demographicNativeAmerican,
    demographicAsian,
    demographicBlack,
    demographicLatin,
    demographicPacificIslander,
    demographicOther,
    demographicMixed,
    demographicWhite,
  } = schoolData

  const femalePercentage = percentFemaleStudents;
  const calcInState = percentInStateStudents ?? (percentOutOfStateStudents === 0 ? 100 : percentInStateStudents)
  const calcOutOfState = percentOutOfStateStudents ?? (percentInStateStudents === 0 ? 100 : percentOutOfStateStudents)

  const ethnicityColumns = []
  if (!!demographicNativeAmerican) {
    ethnicityColumns.push({
      header: <FormattedMessage id="american-indian-alaska-native" defaultMessage="American Indian or Alaska Native"/>, 
      value: demographicNativeAmerican
    })
  }
  if (!!demographicAsian) {
    ethnicityColumns.push({
      header: <FormattedMessage id="asian" defaultMessage="Asian"/>, 
      value: demographicAsian
    })
  }
  if (!!demographicBlack) {
    ethnicityColumns.push({
      header: <FormattedMessage id="black-african-american" defaultMessage="Black or African American"/>, 
      value: demographicBlack
    })
  }
  if (!!demographicLatin) {
    ethnicityColumns.push({
      header: <FormattedMessage id="hispanic-latino" defaultMessage="Hispanic/Latino"/>, 
      value: demographicLatin
    })
  }
  if (!!demographicPacificIslander) {
    ethnicityColumns.push({
      header: <FormattedMessage id="native-hawaiian-pacific-islander" defaultMessage="Native Hawaiian or Pacific Islander"/>, 
      value: demographicPacificIslander
    })
  }
  if (!!demographicOther) {
    ethnicityColumns.push({
      header: <FormattedMessage id="other" defaultMessage="Other"/>, 
      value: demographicOther
    })
  }
  if (!!demographicMixed) {
    ethnicityColumns.push({
      header: <FormattedMessage id="two-more-races" defaultMessage="Two or more races"/>, 
      value: demographicMixed
    })
  }
  if (!!demographicWhite) {
    ethnicityColumns.push({
      header: <FormattedMessage id="White or Caucasian" defaultMessage="White or Caucasian"/>, 
      value: demographicWhite
    })
  }

  return (
  <>
  {(schoolData) && (percentFemaleStudents || totalUndergradStudents || percentMaleStudents) && (
    <>
    <h3 className="tabs-section-heading"><FormattedMessage id="student-body-student-population" defaultMessage="Student Population"/></h3>
    <div className="student-mix">
        {!!percentFemaleStudents &&
          <PieChart
            fractionFilled={femalePercentage}
            fillColor="#FAAD3D"
            emptyColor="#E07306"
          />
        }

      {schoolData && (totalUndergradStudents || percentInStateStudents || percentOutOfStateStudents || percentInternationalStudents || percentFemaleStudents || percentMaleStudents) &&
        <div className="student-mix-stats">
            {!!percentFemaleStudents &&
              <div className="stat-container">
                <div className="percentage female-percentage">{percentFemaleStudents}%</div>
                <div className="percentage-caption">
                  <FormattedMessage id="identify-as-female" defaultMessage="Identify as female"/>
                </div>
              </div>
            }
            {!!percentMaleStudents &&
              <div className="stat-container">
                <div className="percentage male-percentage">{percentMaleStudents}%</div>
                <div className="percentage-caption">
                  <FormattedMessage id="identify-as-male" defaultMessage="Identify as male"/>
                </div>
              </div>
            }
            {!!totalUndergradStudents &&
              <div className="stat-container">
                <div className="percentage total">{totalUndergradStudents.toLocaleString('en')}</div>
                <div className="percentage-caption">
                  <FormattedMessage id="total-undergrad" defaultMessage="Total Undergrad"/>
                </div>
              </div>
            }
            {/* TODO: once Lindsay has spoken with Ellie about design questions, include these stats: {(!!percentOutOfStateStudents || !!percentInStateStudents || !!percentInternationalStudents) && (
              <ul>
                {!!percentInStateStudents && <li>{Math.floor(calcInState)}% <FormattedMessage id="in-state" defaultMessage="In-state"/></li>}
                {!!percentOutOfStateStudents && <li>{Math.floor(calcOutOfState)}% <FormattedMessage id="out-of-state" defaultMessage="Out-of-state"/></li>}
                {!!percentInternationalStudents && <li>{percentInternationalStudents}% <FormattedMessage id="international" defaultMessage="International"/></li>}
              </ul>
            )} */}
        </div>
      }
    </div>
    </>
  )}

  {ethnicityColumns.length > 0 && (
    <div className="student-ethnicity">
      <h3 className="tabs-section-heading"><FormattedMessage id="ethnicity" defaultMessage="Ethnicity"/></h3>
      <div className="table-responsive">
      <Table className="ethnicity-table">
        <thead>
          {ethnicityColumns.map((col, index) => (
            <th key={index}>{col.header}</th>
          ))}
        </thead>
        <tbody>
          {ethnicityColumns.map((col, index) => (
            <td key={index}>{col.value}%</td>
          ))}
        </tbody>
      </Table>
      </div>
    </div>
  )}
  </>
  )
}

export default SectionStudentBody
